"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellTextContent = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const cell_text_content_constants_1 = require("./cell-text-content.constants");
const cell_text_content_styles_1 = require("./cell-text-content.styles");
const multiline_text_1 = require("./multiline-text");
const CellTextContent = ({ tooltipTitle, multiline, multilineOptions, children, expanded, }) => {
    let textContent = react_1.default.createElement(cell_text_content_styles_1.StyledTextContainer, null, children);
    if (multiline) {
        const { maxRows = expanded ? cell_text_content_constants_1.maxRowsExpanded : cell_text_content_constants_1.maxRowsCollapsed, width = '300px', } = multilineOptions !== null && multilineOptions !== void 0 ? multilineOptions : {};
        textContent = (react_1.default.createElement(multiline_text_1.MultilineText, { maxRows: maxRows, width: width }, textContent));
    }
    if (tooltipTitle) {
        textContent = react_1.default.createElement(ui_components_1.ToolTip, { placement: "top-start", title: tooltipTitle }, react_1.default.createElement("span", null, textContent));
    }
    return textContent;
};
exports.CellTextContent = CellTextContent;
